// extracted by mini-css-extract-plugin
export default {"root":"AvailableLocationDisplay_root__VWr33"};